// import React from "react";
import { Route, Routes } from "react-router-dom";

import { useDocument } from "../../../../firebase-files/hooks/useDocument";

import "../plantationTwoCss/PlantationTwoColor.scss";
import "../plantationTwoCss/PlantationTwoFont.scss";
import "../plantationTwoCss/PlantationTwoStyle.scss";

import Navbar from "../../../../default-components/Navbar";
import GlobalRoute from "../../../../global route/GlobalRoute";
import BusinessThreeNavbar from "../../../business/businessThree/businessThreeComponents/BusinessThreeNavbar";
import PlantationTwoHome from "../../../environment/environmentTwo/plantationTwoPages/PlantationTwoHome";
import PlantationTwoAllVideo from "../plantationTwoComponents/PlantationTwoAllVideo";
import PlantationTwoVideo from "../plantationTwoComponents/PlantationTwoVideo";
import PlantationTwoFooter from "../plantationTwoComponents/PlantationTwoFooter";
import FooterUpper from "../../../../default-components/FooterUpper";

const PlantationTwoRoute = () => {
  const { document: navTypeDoc } = useDocument("settings", "navbarType");

  return (
    <div className="plantation_two_route_parent">
      {navTypeDoc && navTypeDoc.activeNav === "FixNav" ? (
        <Navbar />
      ) : (
        <BusinessThreeNavbar />
      )}

      <Routes>
        <Route path="/" element={<PlantationTwoHome />} />
        <Route path="/" element={<PlantationTwoVideo />} />
        <Route path="/videos" element={<PlantationTwoAllVideo />} />
      </Routes>
      <GlobalRoute />
       <FooterUpper/>
      <PlantationTwoFooter />
    </div>
  );
};

export default PlantationTwoRoute;
